import { ChangeDetectorRef, Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { toastrConfig } from 'projects/is-ui-kit/src/lib/core/configs';
import { ActionToastComponent } from 'projects/is-ui-kit/src/lib/core/utils-initializer/utils/custom-notifiers/action-toast/action-toast.component';
import { GenericApiService } from 'projects/licenses-manager/src/app/core/generic-api.service';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  public token: string | null = null;
  public email: string | null = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _toastr: ToastrService,
    private _translate: TranslateService,
    private _cd: ChangeDetectorRef,
    private _apiService: GenericApiService
  ) { }

  ngOnInit(): void {
    this._route.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.email = params['email'];

      if (!this.token || !this.email) {
        this._router.navigate(['/']);
      }
    });
  }

  public passwordMatchValidator: ValidatorFn = (formGroup: AbstractControl): ValidationErrors | null => {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;

    return password && confirmPassword && password !== confirmPassword ? { passwordMismatch: true } : null;
  };

  public resetPasswordForm: FormGroup = new FormGroup({
    password: new FormControl(null, [Validators.required]),
    confirm_password: new FormControl(null, [Validators.required])
  }, { validators: this.passwordMatchValidator });

  public resetPasswordConfirm(): void {
    const obj = {
      token: this.token,
      new_password: this.resetPasswordForm.get('password')?.value,
      new_password_confirm: this.resetPasswordForm.get('confirm_password')?.value
    };
    this._apiService.resetPasswordConfirm((error, response) => {
      if (error) {
        console.error('Errore nella creazione della licenza:', error);
      } else if (response) {
        this._router.navigate(['/']);
        const textToastr = this._translate.instant(response.detail);
        this.showCustomToast({
          type: 'success',
          info: textToastr
        });
      }
    }, obj);
  }

  public showCustomToast(options: {
    type: 'error' | 'success' | 'warning' | 'info';
    info: string;
    buttonText?: string;
  }): ActiveToast<any> {
    const activeToast = this._toastr[options.type](
      (options.info),
      null,
      {
        ...toastrConfig,
        ...{
          timeOut: 7000,
          closeButton: true,
          toastComponent: ActionToastComponent,
          tapToDismiss: false
        }
      }
    );
    activeToast.toastRef.componentInstance.buttonText = options?.buttonText;
    return activeToast;
  }


}
